import React from "react";
import PropTypes from "prop-types";
import Contract from "./Contract";
import Permanent from "./Permanent";

const FeesActiveContent = ({
  inputOnChange,
  jobProfile,
  activeRadioButtonID,
  salaryTypeOnChange,
  errors,
  currencyOptions,
}) => {
  const { salaryMin, contractDuration, contractDurationInterval } = jobProfile;

  let activeContent;

  switch (activeRadioButtonID) {
    case "contract":
      activeContent = (
        <Contract
          inputOnChange={inputOnChange}
          jobProfile={jobProfile}
          salaryMin={salaryMin}
          contractDuration={contractDuration}
          contractDurationInterval={contractDurationInterval}
          errors={errors}
          currencyOptions={currencyOptions}
        />
      );
      break;
    default:
      activeContent = (
        <Permanent
          inputOnChange={inputOnChange}
          jobProfile={jobProfile}
          salaryTypeOnChange={salaryTypeOnChange}
          errors={errors}
          currencyOptions={currencyOptions}
        />
      );
  }

  return activeContent;
};

FeesActiveContent.propTypes = {
  activeRadioButtonID: PropTypes.string.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  salaryTypeOnChange: PropTypes.func.isRequired,
  jobProfile: PropTypes.shape({
    salaryMin: PropTypes.number.isRequired,
    contractDuration: PropTypes.string,
    contractDurationInterval: PropTypes.string,
  }).isRequired,
};

export default FeesActiveContent;
